import React from "react";
import { ICouncilMemberData } from "../exports/interfaces";
import { Dialog, DialogContent, DialogTitle, IconButton } from "@mui/material";
import useMobile from "../hooks/useMobile";

interface CouncilMemberDialogProps {
  open: boolean;
  onClose: () => void;
  member: ICouncilMemberData | null;
}

const PopUpDialog: React.FC<CouncilMemberDialogProps> = ({
  open,
  onClose,
  member,
}) => {
  const mobile = useMobile();
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>
        <h2
          style={{
            margin: "0 0 8px",
            // color: "#2E7D32",
            fontWeight: "bold",
          }}
        >
          {member?.attributes.Name}
        </h2>
        {member?.attributes.Category.toLowerCase().replace(/\b\w/g, (char) =>
          char.toUpperCase()
        )}
        <IconButton
          aria-label="close"
          onClick={onClose}
          size="small"
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            "&:hover": { backgroundColor: "rgba(255, 255, 255, 0.2)" },
          }}
        >
          <i className="icon-cross" style={{ fontSize: "16px" }}></i>
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ padding: "24px", marginTop: "15px" }}>
        <div
          style={{
            display: "flex",
            gap: "24px",
            flexDirection: mobile ? "column" : "row",
          }}
        >
          {/* Image Section */}
          <div
            style={{
              flex: "0 0 35%",
              position: "relative",
              borderRadius: "8px",
              overflow: "hidden",
              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.2)",
              height: "320px",
            }}
          >
            <img
              src={`${process.env.REACT_APP_strapiUrl}${member?.attributes.Image.data.attributes.url}`}
              alt={member?.attributes.Name}
              style={{
                width: "100%",
                height: "320px",
                objectFit: "cover",
                filter: "brightness(0.9)",
              }}
            />
          </div>

          {/* Content Section */}
          <div style={{ flex: "1" }}>
            <p
              style={{
                color: "#727272",
                textAlign: "justify",
                paddingLeft: "12px",
              }}
            >
              {member?.attributes.Description}
            </p>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default PopUpDialog;
